import { Box, Flex, Text } from '@chakra-ui/react';

import { CondensedCatalogCard } from '~/features/catalog/components/condensed-catalog-card';

import { PinIcon } from '../icons';
import { SchoolLpProgram } from '../models/school-lp-program';

export type CareerPathStartingPointsProps = {
  title: string;
  programs: SchoolLpProgram[];
  badgeImage: string;
  bg: string;
};

export function CareerPathStartingPoints({ title, programs, badgeImage, bg }: CareerPathStartingPointsProps) {
  return (
    <Flex
      bg={bg}
      borderBottomRadius='12px'
      borderTopRadius='6px'
      flexDirection='column'
      flexShrink={0}
      gap='12px'
      padding='12px'
      width={{ base: '100%', lg: '354px' }}
    >
      <Flex alignItems='center' gap='12px' padding='6px'>
        <Flex alignItems='center' gap='8px'>
          <PinIcon boxSize='16px' color='white' />
          <Text
            color='white'
            fontFamily='condensed'
            fontSize='0.9375rem'
            fontWeight='500'
            letterSpacing='0.9px'
            lineHeight='1'
            textTransform='uppercase'
            whiteSpace='nowrap'
          >
            {title}
          </Text>
        </Flex>
        <Box bg='whiteAlpha.400' flex={1} height='1px' />
      </Flex>
      <Flex flexDirection='column' gap='8px'>
        {programs.map((program) => (
          <CondensedCatalogCard key={program.key} catalogItem={program} iconPath={badgeImage} />
        ))}
      </Flex>
    </Flex>
  );
}
